/**
 * Custom React hook to initialize the OneTrust cookie consent manager.
 *
 * This hook ensures OneTrust is only initialized when all required conditions are met:
 * - Feature flags are fetched
 * - Not on the logout route
 * - User token is fetched (user is authenticated)
 * - E-consent modal is not visible
 *
 * @param {string} locationPathname - Current route pathname
 * @param {boolean} isTokenFetched - Whether the authentication token is available
 * @param {boolean} isEconsentModalVisible - Whether the e-consent modal is currently visible
 */
import { useEffect } from 'react'
import { initializeOneTrust } from 'helpers/initializeOneTrust'
import routes from 'const/routes'

export function useOneTrust(
  locationPathname: string,
  isTokenFetched: boolean,
  isEconsentModalVisible: boolean,
  isFeatureFlagsFetched: boolean
) {
  useEffect(() => {
    // Only initialize OneTrust if all conditions are met
    if (
      isFeatureFlagsFetched &&
      locationPathname !== routes.LOGOUT &&
      isTokenFetched &&
      !isEconsentModalVisible
    ) {
      initializeOneTrust()
    }
  }, [
    isFeatureFlagsFetched,
    locationPathname,
    isTokenFetched,
    isEconsentModalVisible
  ])
}
